import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { FormattedMessage } from "react-intl";
import {
  TrendingUp as TrendingUpIcon,
  Payment as PaymentIcon,
  AccountBalance as AccountBalanceIcon,
  TouchApp as TouchAppIcon,
} from "@mui/icons-material";
import { PaymentStatistics as PaymentStatsType } from "../../../redux/types/types";

interface PaymentStatisticsProps {
  statistics: PaymentStatsType | null;
  loading: boolean;
}

const PaymentStatistics: React.FC<PaymentStatisticsProps> = ({
  statistics,
  loading,
}) => {
  if (loading || !statistics) {
    return null;
  }

  const formatAmount = (amount: number) => {
    return (amount / 100).toFixed(2);
  };

  const stats = [
    {
      title: "admin.paymentHistory.totalAmount",
      value: `${formatAmount(statistics.totalAmount)} CHF`,
      icon: <AccountBalanceIcon />,
      color: "primary" as const,
    },
    {
      title: "admin.paymentHistory.totalPayments",
      value: `${statistics.totalPayments} (${statistics.successfulPayments} successful)`,
      icon: <PaymentIcon />,
      color: "secondary" as const,
    },
    {
      title: "admin.paymentHistory.stripePayments",
      value: `${statistics.stripePayments.totalCount} (${
        statistics.stripePayments.count
      } successful) - ${formatAmount(statistics.stripePayments.amount)} CHF`,
      icon: <TrendingUpIcon />,
      color: "success" as const,
    },
    {
      title: "admin.paymentHistory.manualPayments",
      value: `${
        statistics.manualPayments.count
      } (all successful) - ${formatAmount(
        statistics.manualPayments.amount
      )} CHF`,
      icon: <TouchAppIcon />,
      color: "warning" as const,
    },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        <FormattedMessage
          id="admin.paymentHistory.statistics"
          defaultMessage="Payment Statistics"
        />
      </Typography>
      <Grid container spacing={2}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card sx={{ height: "100%" }}>
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <Box sx={{ mr: 1, color: `${stat.color}.main` }}>
                    {stat.icon}
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    <FormattedMessage
                      id={stat.title}
                      defaultMessage={stat.title}
                    />
                  </Typography>
                </Box>
                <Typography variant="h6" component="div">
                  {stat.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PaymentStatistics;
